import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { LoggerService } from '../services/logger.service';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(tap(event => {
    if (event.type === HttpEventType.Response) {
      // Log only status code and timestamp, not the full URL (may contain query params with PII)
      logger.debug('HTTP Response', {
        status: event.status,
        timestamp: new Date().toISOString()
      });
    }
  }));
};
